import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import Tag from "../components/Tag";
import Button from "../components/Button";
import InstagramEmbed from "../components/InstagramEmbed";
import { SOCIAL_URLS } from "../constants";

import {
  getScrollAnimationVariants,
  defaultScrollViewportSettings,
  staggerItemVariants,
} from "../hooks/useScrollAnimation";
import "./CaseStudies.css";

const INSTAGRAM_POSTS = [
  "https://www.instagram.com/p/DW4bcxzjR9l/",
  "https://www.instagram.com/p/DW4aOXvDShH/",
  "https://www.instagram.com/p/DW_p3REDfMG/",
  "https://www.instagram.com/p/DW4ZWREjf51/",
];

export default function CaseStudies() {
  const { t } = useTranslation();

  const containerVariants = getScrollAnimationVariants("staggerChildren");

  return (
    <motion.section
      id="case-studies"
      initial="hidden"
      whileInView="visible"
      viewport={defaultScrollViewportSettings}
      variants={containerVariants}
    >
      <div className="section-title">
        <Tag>{t("caseStudies.portfolio")}</Tag>
        <h2>{t("caseStudies.title")}</h2>
        <p>{t("caseStudies.subtitle")}</p>
      </div>

      <div className="instagram-grid">
        {INSTAGRAM_POSTS.map((url, index) => (
          <motion.div key={index} variants={staggerItemVariants}>
            <InstagramEmbed postUrl={url} />
          </motion.div>
        ))}
      </div>

      <div className="instagram-follow-cta">
        <Button
          variant="secondary"
          size="large"
          href={SOCIAL_URLS.instagram}
          target="_blank"
        >
          {t("caseStudies.followUs")}
        </Button>
      </div>
    </motion.section>
  );
}
